import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-light-svg-icons";
import { useTranslation } from "react-i18next";
import Navbar from "../components/Navbar";

const Exception403 = () => {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <div className="h-screen justify-center items-center flex">
        <ul className="text-center">
          <li>
            <FontAwesomeIcon icon={faExclamationCircle} className="text-7xl" />
          </li>
          <li className="mt-4">{t("global.access_denied")}</li>
        </ul>
      </div>
    </>
  );
};

export default Exception403;
